var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAxisLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 115,
    viewBox: "0 0 486 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.159 102.416H202.95L209.806 114.253H221.016L214.159 102.416ZM184.541 114.253H195.935L202.791 102.416L208.375 92.6044L202.95 83.0776L184.541 114.253Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.721 99.4603H339.104L337.706 102.131H335.513L341.925 90.5781L348.145 102.131H346.111L344.713 99.4603H344.721ZM343.96 97.9032L341.925 94.1611L339.891 97.9032H343.951H343.96Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.419 99.4603H365.801L364.403 102.131H362.21L368.589 90.5781L374.843 102.131H372.808L371.41 99.4603H371.419ZM370.623 97.9032L368.589 94.1611L366.555 97.9032H370.615H370.623Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.918 99.4603H223.3L221.902 102.131H219.709L226.122 90.5781L232.342 102.131H230.307L228.909 99.4603H228.918ZM228.156 97.9032L226.122 94.1611L224.087 97.9032H228.147H228.156Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.988 96.5151L233.397 91.2075H235.749L238.252 94.958L240.889 91.2075H243.083L239.332 96.5151L243.242 102.132H241.048L238.093 97.9131L235.113 102.132H232.953L236.988 96.5151Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.698 91.2075H244.823V102.124H246.698V91.2075Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.51 92.7649L254.953 93.5602C254.635 93.083 254.351 92.7649 254.032 92.6058C253.873 92.4468 253.396 92.4468 252.919 92.4468C252.475 92.4468 251.998 92.6058 251.68 92.7649C251.203 93.083 251.044 93.4011 251.044 93.7192C251.044 94.322 251.521 94.7992 252.475 95.1173L253.873 95.561C254.953 95.8791 255.59 96.3562 256.226 96.8334C256.669 97.2771 256.829 97.9134 256.829 98.7087C256.829 99.6295 256.51 100.584 255.749 101.187C254.794 101.823 253.873 102.141 252.634 102.141C251.521 102.141 250.6 101.982 249.813 101.346C249.21 100.709 248.733 99.9476 248.574 98.9933L250.449 98.5496C250.608 99.1523 250.768 99.6295 250.927 99.9476C251.37 100.425 252.007 100.584 252.768 100.584C253.405 100.584 253.882 100.425 254.359 100.107C254.644 99.7886 254.962 99.3114 254.962 98.8677C254.962 98.5496 254.803 98.3905 254.803 98.2315C254.644 98.0724 254.644 97.9134 254.518 97.7543C254.359 97.5952 254.2 97.4362 253.882 97.2771C253.723 97.1181 253.405 97.1515 253.086 96.9925L251.847 96.5153C249.972 95.8791 249.051 94.9582 249.051 93.7192C249.051 92.9239 249.495 92.2877 250.29 91.6849C250.927 91.2078 251.847 90.8896 253.086 90.8896C254.518 90.8896 255.757 91.5259 256.519 92.7649H256.51Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M424.56 101.973H426.494V94.1286C426.846 94.5723 427.256 94.9574 427.733 95.3341L436.079 101.964V90.4702H434.171V98.2809C433.727 97.8372 433.283 97.3935 432.739 96.9833L424.552 90.4786V101.973H424.56Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M410.813 96.4131L412.211 102.131H414.179L411.064 90.5781L407.322 97.3088C407.13 97.6604 406.845 98.1376 406.594 98.7404C406.242 97.9786 405.991 97.5014 405.899 97.3088L402.09 90.5781L399.043 102.131H400.977L402.375 96.4131C402.467 95.9359 402.567 95.4587 402.601 94.9564C402.76 95.4336 402.986 95.8773 403.237 96.321L406.602 102.131L409.968 96.4131C410.286 95.9359 410.478 95.4587 410.571 94.9564C410.696 95.7517 410.763 96.2289 410.822 96.4131H410.813Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M390.589 102.131H397.763V100.482H392.657V96.8317H397.763V95.2411H392.657V92.4199H397.763V90.8628H390.589V102.131Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M415.445 102.131H422.62V100.482H417.547V96.8317H422.62V95.2411H417.547V92.4199H422.62V90.8628H415.445V102.131Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M382.812 96.1957V97.7193H386.018V97.8784C386.018 99.4941 384.528 100.515 382.05 100.515C379.162 100.515 377.161 98.8327 377.161 96.3548C377.161 93.8768 379.195 92.2276 382.017 92.2276C383.415 92.2276 384.528 92.6378 385.415 93.5001L387.006 92.5122C385.734 91.2146 384.084 90.6035 381.992 90.6035C380.024 90.6035 378.249 91.1728 376.944 92.1941C375.612 93.274 374.909 94.7056 374.909 96.3548C374.909 98.0039 375.604 99.469 376.843 100.515C378.141 101.595 379.823 102.131 381.983 102.131C385.859 102.131 388.111 100.356 388.111 97.2421C388.111 96.991 388.078 96.6394 388.078 96.1957H382.812Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M349.417 102.29H351.351V94.4205C351.702 94.8642 352.113 95.2493 352.59 95.626L360.936 102.29V90.7705H359.002V98.5811C358.592 98.1375 358.115 97.6938 357.604 97.2836L349.417 90.7789V102.298V102.29Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M331.292 96.4131L332.724 102.131H334.658L331.544 90.5781L327.827 97.3088C327.634 97.6604 327.316 98.1376 327.065 98.7404C326.713 97.9786 326.496 97.5014 326.37 97.3088L322.561 90.5781L319.514 102.131H321.447L322.846 96.4131C322.971 95.9359 323.072 95.4587 323.072 94.9564C323.231 95.4336 323.448 95.8773 323.708 96.321L327.073 102.131L330.472 96.4131C330.757 95.9359 330.949 95.4587 331.041 94.9564C331.167 95.7517 331.234 96.2289 331.292 96.4131Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M310.314 92.4199H313.705V90.8628H304.789V92.4199H308.213V102.131H310.314V92.4199Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M442.618 92.4199H446.017V90.8628H437.093V92.4199H440.525V102.131H442.618V92.4199Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M296.568 102.131H303.776V100.482H298.661V96.8317H303.776V95.2411H298.661V92.4199H303.776V90.8628H296.568V102.131Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.588 99.4603H267.97L266.572 102.131H264.379L270.791 90.5781L277.012 102.131H274.977L273.579 99.4603H273.588ZM272.826 97.9032L270.791 94.1611L268.757 97.9032H272.817H272.826Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.46 92.7649L283.869 93.5602C283.585 93.083 283.267 92.7649 282.948 92.6058C282.789 92.4468 282.312 92.4468 281.869 92.4468C281.391 92.4468 280.914 92.6058 280.596 92.7649C280.152 93.083 279.993 93.4011 279.993 93.7192C279.993 94.322 280.437 94.7992 281.391 95.1173L282.789 95.561C283.869 95.8791 284.506 96.3562 285.142 96.8334C285.585 97.2771 285.745 97.9134 285.745 98.7087C285.745 99.6295 285.46 100.584 284.665 101.187C283.744 101.823 282.789 102.141 281.55 102.141C280.437 102.141 279.516 101.982 278.729 101.346C278.126 100.709 277.649 99.9476 277.49 98.9933L279.365 98.5496C279.525 99.1523 279.684 99.6295 279.843 99.9476C280.32 100.425 280.923 100.584 281.718 100.584C282.321 100.584 282.798 100.425 283.275 100.107C283.593 99.7886 283.878 99.3114 283.878 98.8677C283.878 98.5496 283.752 98.3905 283.752 98.2315C283.593 98.0724 283.593 97.9134 283.434 97.7543C283.275 97.5952 283.116 97.4362 282.798 97.2771C282.639 97.1181 282.321 97.1515 282.036 96.9925L280.764 96.5153C278.888 95.8791 277.967 94.9582 277.967 93.7192C277.967 92.9239 278.445 92.2877 279.206 91.6849C279.843 91.2078 280.763 90.8896 282.028 90.8896C283.426 90.8896 284.665 91.5259 285.46 92.7649Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.727 92.7649L293.17 93.5602C292.852 93.083 292.534 92.7649 292.216 92.6058C292.057 92.4468 291.613 92.4468 291.136 92.4468C290.659 92.4468 290.181 92.6058 289.897 92.7649C289.42 93.083 289.26 93.4011 289.26 93.7192C289.26 94.322 289.738 94.7992 290.659 95.1173L292.057 95.561C293.17 95.8791 293.773 96.3562 294.409 96.8334C294.886 97.2771 295.045 97.9134 295.045 98.7087C295.045 99.6295 294.727 100.584 293.932 101.187C293.011 101.823 292.057 102.141 290.818 102.141C289.738 102.141 288.783 101.982 288.021 101.346C287.385 100.709 286.908 99.9476 286.749 98.9933L288.624 98.5496C288.783 99.1523 288.942 99.6295 289.101 99.9476C289.579 100.425 290.181 100.584 290.977 100.584C291.613 100.584 292.057 100.425 292.534 100.107C292.852 99.7886 293.17 99.3114 293.17 98.8677C293.17 98.5496 293.011 98.3905 293.011 98.2315C292.852 98.0724 292.852 97.9134 292.693 97.7543C292.534 97.5952 292.375 97.4362 292.057 97.2771C291.898 97.1181 291.613 97.1515 291.295 96.9925L290.022 96.5153C288.181 95.8791 287.226 94.9582 287.226 93.7192C287.226 92.9239 287.703 92.2877 288.465 91.6849C289.101 91.2078 290.022 90.8896 291.286 90.8896C292.684 90.8896 293.923 91.5259 294.719 92.7649H294.727Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M165.035 91.4824V96.5556C165.58 95.9863 166.207 95.7017 166.894 95.7017C167.689 95.7017 168.359 96.0031 168.886 96.6058C169.414 97.2002 169.682 97.9452 169.682 98.8326C169.682 99.72 169.414 100.515 168.878 101.11C168.351 101.704 167.672 102.005 166.869 102.005C166.182 102.005 165.571 101.738 165.035 101.21V101.838H163.671V91.4824H165.035ZM168.292 98.8912C168.292 98.322 168.141 97.8532 167.832 97.4932C167.522 97.1248 167.128 96.9407 166.66 96.9407C166.157 96.9407 165.747 97.1165 165.429 97.4764C165.119 97.828 164.96 98.2885 164.96 98.8494C164.96 99.4103 165.111 99.8958 165.421 100.239C165.73 100.591 166.132 100.775 166.634 100.775C167.112 100.775 167.505 100.599 167.815 100.239C168.133 99.8791 168.292 99.427 168.292 98.8912Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M172.779 100.726L170.117 95.8623H171.708L173.516 99.2946L175.207 95.8623H176.756L172.034 105.079H170.469L172.779 100.718V100.726Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2925 37.8309L15.8548 49.8106H8.30371L35.2349 0L62.1661 49.8106H54.615L48.1773 37.8309H22.2925ZM35.2349 13.0512L25.2142 32.3811H45.264L35.2433 13.0512H35.2349Z",
    fill: "url(#paint0_linear_7143_34397)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5897 44.3602H99.6281V49.8101H69.5576V2.02539H76.5897V44.3602Z",
    fill: "url(#paint1_linear_7143_34397)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M118.055 49.8101H111.023V7.47525H94.6738V2.02539H134.397V7.47525H118.047V49.8101H118.055Z",
    fill: "url(#paint2_linear_7143_34397)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M142.935 2.02539H173.231V7.47525H149.967V20.8446H172.561V26.2944H149.967V44.3602H173.231V49.8101H142.935V2.02539Z",
    fill: "url(#paint3_linear_7143_34397)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M219.149 49.8101H210.619L194.009 29.5928H191.088V49.8101H184.056V2.02539H192.586C197.601 2.02539 202.984 2.09236 207.471 4.24384C212.184 6.58787 214.88 11.0918 214.88 15.6542C214.88 22.5021 209.497 28.2032 201.343 29.0236L219.149 49.8101ZM191.096 24.6536H193.34C200.522 24.6536 208.3 23.5151 208.3 15.9054C208.3 8.29566 199.92 7.34968 192.963 7.34968H191.096V24.6536Z",
    fill: "url(#paint4_linear_7143_34397)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M227.998 1.22217L265.904 37.3286V2.02583H272.936V51.7778L235.03 15.6714V51.2923H227.998V1.22217Z",
    fill: "url(#paint5_linear_7143_34397)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M294.669 37.8309L288.232 49.8106H280.681L307.612 0L334.543 49.8106H326.992L320.554 37.8309H294.669ZM307.612 13.0512L297.591 32.3811H317.641L307.62 13.0512H307.612Z",
    fill: "url(#paint6_linear_7143_34397)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M348.884 49.8101H341.852V7.47525H325.502V2.02539H365.225V7.47525H348.875V49.8101H348.884Z",
    fill: "url(#paint7_linear_7143_34397)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M372.615 2.02539H402.912V7.47525H379.647V20.8446H402.242V26.2944H379.647V44.3602H402.912V49.8101H372.615V2.02539Z",
    fill: "url(#paint8_linear_7143_34397)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M438.608 11.0915C436.515 8.11126 433.82 6.58764 429.559 6.58764C425.071 6.58764 420.132 9.18282 420.132 13.3686C420.132 17.1107 424.469 19.0696 427.985 20.2165L432.02 21.5476C440.023 24.2097 446.009 27.9518 446.009 35.9298C446.009 44.6111 438.081 50.8228 427.976 50.8228C418.851 50.8228 411.744 45.1218 410.547 37.4535L417.654 36.1894C417.579 41.4467 422.518 45.2557 428.579 45.2557C434.64 45.2557 438.977 40.9444 438.977 35.9382C438.977 30.932 434.113 28.588 429.249 26.8718L425.356 25.4738C418.918 23.1298 413.092 20.0239 413.092 13.3686C413.092 5.63329 421.17 1.01221 429.701 1.01221C435.988 1.01221 441.145 3.60738 444.217 8.23684L438.608 11.0915Z",
    fill: "url(#paint9_linear_7143_34397)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M415.186 58.3457H4.08523L-7.86749e-05 65.8968H441.924L446.01 58.3457H415.186Z",
    fill: "url(#paint10_linear_7143_34397)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M481.121 58.3446L485.206 50.7935H450.096L446.011 58.3446H481.121Z",
    fill: "url(#paint11_linear_7143_34397)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7143_34397",
    x1: 592.728,
    y1: -106.595,
    x2: -65.7508,
    y2: 52.5732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7143_34397",
    x1: 594.946,
    y1: -97.4451,
    x2: -63.5413,
    y2: 61.7228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7143_34397",
    x1: 596.145,
    y1: -92.4724,
    x2: -62.3425,
    y2: 66.6954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7143_34397",
    x1: 598.999,
    y1: -80.6602,
    x2: -59.4806,
    y2: 78.5077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7143_34397",
    x1: 601.402,
    y1: -70.7232,
    x2: -57.0862,
    y2: 88.4448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7143_34397",
    x1: 604.231,
    y1: -59.011,
    x2: -54.2481,
    y2: 100.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7143_34397",
    x1: 607.765,
    y1: -44.3942,
    x2: -50.7146,
    y2: 114.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7143_34397",
    x1: 608.887,
    y1: -39.7569,
    x2: -49.5928,
    y2: 119.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7143_34397",
    x1: 611.681,
    y1: -28.2042,
    x2: -46.8067,
    y2: 130.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7143_34397",
    x1: 613.95,
    y1: -18.8199,
    x2: -44.5381,
    y2: 140.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7143_34397",
    x1: 612.302,
    y1: -32.4685,
    x2: -46.1857,
    y2: 126.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7143_34397",
    x1: 624.081,
    y1: 16.2609,
    x2: -34.4056,
    y2: 175.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxisLogo1);
export default __webpack_public_path__ + "static/media/AxisLogo1.ca12e9dc9305869c4df7e79ae6349bef.svg";
export { ForwardRef as ReactComponent };